export default __webpack_public_path__ + "static/media/car4.c2e0b349.jpg";